import axiosInstance from './axiosInstance';

export const getAppConfigs = () => axiosInstance.get('/api/v1/app-config');
export const updateAppConfig = (appName, data) => axiosInstance.patch(`/api/v1/app-config/${appName}`, data);
